import Service from "../../Services";

const Banner = {
  namespaced : true,
  state : {
    form : {
      branch_id : '',
      title : '',
      is_active : true,
      effect : null,
      time_effect : '',
      desktop_images : [],
      mobile_images : [],
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        branch_id : '',
        title : '',
        is_active : true,
        effect : null,
        time_effect : '',
        desktop_images : [],
        mobile_images : [],
      }
    },
    REMOVE_SLIDE_MOBILE_IMAGE: (state, index) => {
      state.form.mobile_images = state.form.mobile_images.filter(
        (detail, itemIndex) => index !== itemIndex
      );
    },
    REMOVE_SLIDE_DESKTOP_IMAGE: (state, index) => {
      state.form.desktop_images = state.form.desktop_images.filter(
        (detail, itemIndex) => index !== itemIndex
      );
    }
  },
  actions : {
    getBanner({commit},page){
      return Service.BannerAPI.getBanner(page);
    },
    showBanner({commit},id){
      return Service.BannerAPI.showBanner(id);
    },
    saveBanner({commit},{id,data}){
      if(id){
        return Service.BannerAPI.updateBanner(id,data);
      }else{
        return Service.BannerAPI.createBanner(data);
      }
    },
    deleteBanner({commit},id){
      return Service.BannerAPI.deleteBanner(id);
    },
    setFormBanner({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    },
    removeMobileImage({commit},index){
      commit('REMOVE_SLIDE_MOBILE_IMAGE',index);
    },
    removeDesktopImage({commit},index){
      commit('REMOVE_SLIDE_DESKTOP_IMAGE',index);
    },
  },
}
export default Banner
